

export default function EventsError() {
    return <>
        <div className="container body-text">
            <div className="events-intro body-text">
                <h2>Community Events</h2>
                <p>Ridgewood Civic hosts a variety of neighborhood events throughout the year, bringing our community together to celebrate and connect. From seasonal celebrations to summer block parties, our events are what make Ridgewood special.</p>
                <p><span className="figtree-bold">Free for All Residents:</span> Thanks to the generosity of our neighbors, most events are free to attend. These gatherings are made possible through annual dues and donations from community members who believe in fostering a connected, vibrant neighborhood.</p>
                <p>Whether you're new to Ridgewood or have been here for years, we encourage you to join us at our next event. It's a great way to meet neighbors, build friendships, and strengthen our community bonds.</p>
            </div>
        </div>
    </>
}